import { Breadcrumb } from 'components/breadcrumbs/types'
import { StructuredData } from 'types/structured-data'
import dayjs from 'dayjs'

import { CmsJobOffer } from 'types/cms/collection-types'

export const generateArticleStructuredData = ({ type, title, thumbnail, datePublished, dateUpdated, authorName }: StructuredData) => ({
  __html: `{
    "@context": "https://schema.org",
    "@type": "${type}",
    "headline": "${title}",
    "image": ["${thumbnail}"],
    "datePublished": "${dayjs(datePublished).toISOString()}",
    "dateModified": "${dayjs(dateUpdated).toISOString()}",
    "author": [{
        "@type": "Person",
        "name": "${authorName}"
    }],
    "publisher": {
      "@type": "Organization",
      "name": "Bolt",
      "logo": {
        "@type": "ImageObject",
        "url": "https://res.cloudinary.com/bolt-energie/image/upload/v1646928673/Bolt_logo_RGB_yh5vny.svg"
      }
    }
  }`
})

export const generateBreadcrumbsStructuredData = (breadcrumbs: Breadcrumb[]) => ({
  __html: `{
    "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
      ${breadcrumbs.map(
        (crumb, index) => `{
          "@type": "ListItem",
          "position": "${index + 1}",
          "name": "${crumb.title}",
          "item": "https://boltenergie.be${crumb.href}"
        }`
      )}
    ]
  }`
})

export const generateJobPostingStructuredData = (jobOffer: CmsJobOffer) => ({
  __html: `{
    "@context" : "https://schema.org/",
    "@type" : "JobPosting",
    "title" : "${jobOffer.attributes.title}",
    "description" : "${jobOffer.attributes.description?.replace(/"/g, "'")}",
    "datePosted" : "${dayjs(jobOffer.attributes.publishedAt).toISOString()}",
    "hiringOrganization" : {
      "@type" : "Organization",
      "name" : "Bolt",
      "sameAs" : "https://www.boltenergie.be",
      "logo" : "https://res.cloudinary.com/bolt-energie/image/upload/v1664965457/Bolt_LOGO_RGB_itbd9x.png"
    },
    "jobLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Sint-Lazaruslaan",
        "addressLocality": "Botanic Tower",
        "addressRegion": "Brussel",
        "postalCode": "1210",
        "addressCountry": "BE"
      }
    }
  }`
})
